/*import axios from 'axios'
import React, { Component } from 'react'*/
import React, { Component } from 'react'
import $ from 'jquery';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { NavbarLog } from '../../navbar/NavbarLog';
import { Table, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, ListGroupItemText, Alert } from 'reactstrap';
//import "./Carrera.css";
import { ApiUrl } from '../../services/ApiRest';
import swal from 'sweetalert';

//Rutas de ingreso de matriz
const devuelNumNivelesCarrera = ApiUrl + "numnivelescarr" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const carrerasUrl = ApiUrl + "listarcarreras" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlListarEstMatCiclo = ApiUrl + "listarestmatciclobec" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlModEstadPensM = ApiUrl + "modestadpagpensmescol" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlInsertarBecaEst = ApiUrl + "insertarbecaEst" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarBecasEst = ApiUrl + "ListarbecasEst" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlEliminarBecasEst = ApiUrl + "EliminarbecasEst" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
//const urlListarPeriodos = ApiUrl + "listperiodostodos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlPeriodosCarrera = ApiUrl + "listperiodoscarrera" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

let listaauxiliar = [];
const itemsPerPage = 10;

export default class EstCarreraCicloBecas extends Component {

    constructor(props) {
        super(props)

        this.state = {
            periodos: [],
            nivel1: '',
            nivel2: '',
            nivel3: '',
            nivel4: '',
            nivel5: '',
            nivel6: '',
            periodo: '',
            idPeriodo: 3,
            EstudianteBackup: [],

            carrera_seleccionada: '',
            ciclo_seleccionado: '',
            carrera: [],
            id: '',
            monto: '',
            arancel: '',
            manutencion: '',
            tipo_beca_id: '',
            financiamiento: '',
            razon1: '',
            razon2: '',
            razon3: '',
            razon4: '',
            razon5: '',
            razon6: '',
            periodo: '',
            modalReportIngresarBecas: false,

            //nuevas variables
            numnivelescarr: '',
            periodosId: [],
            listaniveles: [],
            listaestudiantes: [],
            listabecas: [],
            listaperiodos: [],
            //variables para paginacion
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            count: 0,
        }
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ carrera_seleccionada: this.state.idCarrera });
        this.setState({ estado: "" });
    }

    handleChangePeriodo = (event) => {
        this.setState({ periodo: event.target.value });
    };

    handleChangeDevolverIdCarrera = async (e) => {


        await this.setState({ [e.target.name]: e.target.value })
        //var  = this.state.idCarrera;
        this.setState({ carrera_seleccionada: this.state.idCarrera });
        //devuelve los niveles de  una carrera y los datos registrados de colegiatura para cada uno de ellos
        axios
            .post(devuelNumNivelesCarrera, {
                idCarreraf: this.state.idCarrera,
                periodoIdf: this.state.idPeriodo,
            })
            .then(response => {
                const listaniveles1 = response.data.data;
                this.setState({ listaniveles: listaniveles1 });
            })
            .catch(error => {
                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });

        //lista los períodos en base a la carrera

        axios
            .post(urlPeriodosCarrera, {//guarda para enviar los atributos y envia
                idCarrera: this.state.idCarrera,
            })
            .then(response => {
                const listaperiodos = response.data.data;
                const cant = listaperiodos.length;
                if (cant != 0) {
                    this.setState({ periodos: listaperiodos });
                    const idUltPeriod = listaperiodos[cant - 1].id_periodo_academico;
                    $(function () {
                        $("#idPeriodo").val(idUltPeriod);
                    });
                    this.setState({ idPeriodo: idUltPeriod });
                }
            });

    }

    handleChangeDevolverIdCiclo = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        //var  = this.state.idCarrera;
        this.setState({ ciclo_seleccionado: this.state.idCiclo });
        //devuelve los niveles de  una carrera y los datos registrados de colegiatura para cada uno de ellos
    }

    handleChangeListarEstMatCiclo = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        //var  = this.state.idCarrera;

        this.setState({ ciclo_seleccionado: this.state.idCiclo });
        axios
            .post(UrlListarEstMatCiclo, {
                idCarrera: this.state.carrera_seleccionada,
                idCiclo: this.state.ciclo_seleccionado,
                idPeriodo: this.state.idPeriodo,
            })
            .then(response => {

                if (response.data.data != "") {
                    var array = response.data.data;
                    var hash = {};
                    array = array.filter(function (current) {
                        var exists = !hash[current.id_matricula];
                        hash[current.id_matricula] = true;
                        return exists;
                    });
                    this.setState({ listaestudiantes: array });
                    listaauxiliar = this.state.listaestudiantes;
                    var cantidadestud = listaauxiliar.length;
                    this.setState({ cantidadestud });
                    //BÚSQUEDA
                    const EstudianteBackup = this.state.listaestudiantes;

                    this.setState((state) => {
                        return { EstudianteBackup: EstudianteBackup }
                    });


                    //PAGINACION
                    this.state.itemOffset = 0;
                    const endOffset = this.state.itemOffset + itemsPerPage;
                    this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                    this.setState({ EstudianteBackup: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                    this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });

                    this.setState((state) => {
                        return { itemOffset: state.itemOffset + endOffset }
                    });

                    //FIN DE LA PAGINACION
                } else {
                    this.setState({ error: "No existe estudiantes matriculados!" });
                    swal({
                        text: "¡No existe estudiantes matriculados!",
                        icon: "warning",
                        button: "Aceptar",
                    });
                }


            })
            .catch(error => {
                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    }

    //BUSQUEDA......
    filter(event) {
        console.log(event.target.value);
        //obtener datos de buscar
        var text = event.target.value
        //obtener datos del array
        const data = this.state.listaestudiantes;
        var newData = data.filter(function (item) {
            //variable del objeto
            const itemDataPrimerApell = item.primer_apellido_estudiante.toUpperCase()
            const itemDataPrimerNom = item.primer_nombre_estudiante.toUpperCase()
            const itemDataCedula = item.numero_identificacion_estudiante.toUpperCase()
            const campo = itemDataPrimerApell + " " + itemDataPrimerNom + " " + itemDataCedula;
            //variable del buscador
            const textData = text.toUpperCase()
            return campo.indexOf(textData) > -1
        })
        if (text == "") {
            newData = this.state.EstudianteBackup;
        }

        this.setState({
            currentItems: newData,
        })
        console.log(this.state.currentItems)
    }

    componentDidMount() {
        document.addEventListener("keydown", this.escFunction, true);
        axios.get(carrerasUrl)
            .then(res => {
                const carrera = res.data;
                this.setState({ carrera });
            })

        //periodos
        /*axios.get(ApiUrl + "periodos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71")
            .then(respuesta => {
                const periodos = respuesta.data.descripcion_periodo_academico;
                const periodosId = respuesta.data.id_periodo_academico;
                this.setState({ periodoId: respuesta.data.id_periodo_academico });
                this.setState({ periodos });
                this.setState({ periodosId });
                // console.log("periodos"+periodosId);
            })*/
    }

    //FUNCION DE PAGINACION POR  MEDIO DE UN CLIC
    handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
        const endOffset = newOffset + itemsPerPage;
        this.setState({ currentItems: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ EstudianteBackup: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
        this.setState((state) => {
            // Importante: lee state en vez de this.state al actualizar.
            return { itemOffset: newOffset }
        });
    }
    //FIN DE PAGINACION

    seleccionarEstudianteuno = async (e) => {
        var id_estudiante = "";
        $(".afiliado:checked").each(function () {
            id_estudiante = $(this).parent().parent().find('td').eq(3).html();
            //nombrescompletos=$(this).parent().parent().find('td').eq(1).html()+" "+$(this).parent().parent().find('td').eq(2).html()+" "+$(this).parent().parent().find('td').eq(3).html()+" "+$(this).parent().parent().find('td').eq(4).html();
        });

        axios
            .post(urlListarBecasEst, {
                idEstudiante: id_estudiante,
            })
            .then(response => {

                const respuesta = response.data.data;
                this.setState({ listabecas: respuesta });
            })

        //periodos
        /*   axios.get(urlListarPeriodos)
               .then(response => {
                   const respuesta = response.data.data;
                   this.setState({ listaperiodos: respuesta });
               })*/
    }

    mostrarModalIngresar = () => {
        this.setState({ id: 0 });
        this.setState({ modalReportIngresarBecas: true });
    }

    mostrarModalModificar = (registro) => {
        $(function () {
            $("#id").val(registro.id_beca);
            $("#monto").val(registro.monto);
            $("#arancel").val(registro.porcentaje_arancel);
            $("#manutencion").val(registro.porcentaje_manuntencion);
            $("#tipo_beca_id").val(registro.tipo_beca_id);
            $("#financiamiento").val(registro.financiamiento_beca);
            $("#razon1").val(registro.primera_razon_beca);
            $("#razon2").val(registro.segunda_razon_beca);
            $("#razon3").val(registro.tercera_razon_beca);
            $("#razon4").val(registro.cuarta_razon_beca);
            $("#razon5").val(registro.quinta_razon_beca);
            $("#razon6").val(registro.sexta_razon_beca);
            $("#periodo").val(registro.periodo_academico_id);
        });

        this.setState({ id: registro.id_beca });
        this.setState({ monto: registro.monto });
        this.setState({ arancel: registro.porcentaje_arancel });
        this.setState({ manutencion: registro.porcentaje_manuntencion });
        this.setState({ tipo_beca_id: registro.tipo_beca_id });
        this.setState({ financiamiento: registro.financiamiento_beca });
        this.setState({ razon1: registro.primera_razon_beca });
        this.setState({ razon2: registro.segunda_razon_beca });
        this.setState({ razon3: registro.tercera_razon_beca });
        this.setState({ razon4: registro.cuarta_razon_beca });
        this.setState({ razon5: registro.quinta_razon_beca });
        this.setState({ razon6: registro.sexta_razon_beca });
        this.setState({ periodo: registro.periodo_academico_id });
        this.setState({ modalReportIngresarBecas: true });
    }

    ocultarModalIngresar = () => {
        this.setState({ modalReportIngresarBecas: false });
    }

    registrarBeca = () => {


        var id_estudiante = "";
        $(".afiliado:checked").each(function () {
            id_estudiante = $(this).parent().parent().find('td').eq(3).html();
            //nombrescompletos=$(this).parent().parent().find('td').eq(1).html()+" "+$(this).parent().parent().find('td').eq(2).html()+" "+$(this).parent().parent().find('td').eq(3).html()+" "+$(this).parent().parent().find('td').eq(4).html();
        });

        const f = new FormData();
        f.append("id", this.state.id);
        f.append("monto", this.state.monto);
        f.append("porcentaje_arancel", this.state.arancel);
        f.append("porcentaje_manuntencion", this.state.manutencion);
        f.append("tipo_beca_id", this.state.tipo_beca_id);
        f.append("primera_razon_beca", this.state.razon1);
        f.append("segunda_razon_beca", this.state.razon2);
        f.append("tercera_razon_beca", this.state.razon3);
        f.append("cuarta_razon_beca", this.state.razon4);
        f.append("quinta_razon_beca", this.state.razon5);
        f.append("sexta_razon_beca", this.state.razon6);
        f.append("financiamiento_beca", this.state.financiamiento);
        f.append("idEstudiante", id_estudiante);
        f.append("periodo_academico_id", this.state.periodo);
        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }

        axios.post(urlInsertarBecaEst, f, {

        }, config)
            .then(response => {
                if (response.data.success === true) {
                    swal({
                        text: "Operación Exitosa!!",
                        icon: "success",
                        button: "Aceptar",
                    });
                    this.seleccionarEstudianteuno();
                    this.ocultarModalIngresar();
                }
            })
            .catch(error => {
                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    }

    eliminarBeca = (id) => {
        swal({
            title: "Advertencia",
            text: "Está seguro de continuar?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    axios.post(urlEliminarBecasEst, {
                        id: id,
                    })
                        .then(response => {
                            if (response.data.success === true) {
                                swal({
                                    text: "Beca Eliminada Exitosamente!!",
                                    icon: "success",
                                    button: "Aceptar",
                                });
                                this.seleccionarEstudianteuno();
                            }
                        })
                        .catch(error => {
                            this.setState({ error: "No existe conexión con el servidor" });
                            swal({
                                text: "No existe conexión con el servidor",
                                icon: "error",
                                button: "Aceptar",
                            });
                        });
                } else {
                    swal({
                        text: "¡Haz denegado la acción!",
                        icon: "warning",
                        button: "Aceptar",
                    });
                }
            });
    }

    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <div className="card p-3 mb-2 bg-white rounded-4 shadow-sm border-0">
                    <div className="back-istmas">
                        <i className="fa fa-comment-dollar bounce-custom fs-5"></i>
                        <b className="mb-0 fw-semibold"> Asignar becas a estudiantes</b>
                    </div>

                    <div className="p-3 rounded-3 mt-1">
                        <div className="row g-3">
                            <div className="col-12 col-md-6 col-xl-4">
                                <label className="form-label text-muted small">Carrera:</label>
                                <select
                                    className="form-select form-select-sm"
                                    name="idCarrera"
                                    value={this.state.value}
                                    onChange={this.handleChangeDevolverIdCarrera}
                                >
                                    <option value="undefined" selected disabled>Seleccione una carrera</option>
                                    {this.state.carrera.map(person => (
                                        <option key={person.id_carrera} value={person.id_carrera}>
                                            {person.descripcion_carrera}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-12 col-md-6 col-xl-4">
                                <label className="form-label text-muted small">Ciclos:</label>
                                <select
                                    className="form-select form-select-sm"
                                    name="idCiclo"
                                    value={this.state.value}
                                    onChange={this.handleChangeDevolverIdCiclo}
                                >
                                    <option value="undefined" disabled>Seleccione un ciclo</option>
                                    {this.state.listaniveles.map(consola => (
                                        <option key={consola.codnivel} value={consola.codnivel}>
                                            {consola.codnivel}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="row g-3 mt-1">
                            <div className="col-12 col-md-6 col-xl-4">
                                <label className="form-label text-muted small">
                                    <i className="fa fa-calendar me-1"></i> Período:
                                </label>
                                <select
                                    className="form-select form-select-sm"
                                    id="idPeriodo"
                                    name="idPeriodo"
                                    value={this.state.value}
                                    onChange={this.handleChangePeriodo}
                                >
                                    <option value="undefined" disabled>Seleccione el período</option>
                                    {this.state.periodos.map(periodo => (
                                        <option key={periodo.id_periodo_academico} value={periodo.id_periodo_academico}>
                                            {periodo.descripcion_periodo_academico}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-12 col-md-6 col-xl-4">
                                <label className="form-label text-muted small">
                                    <i className="fa fa-search me-1"></i> Buscar:
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={this.state.text}
                                    placeholder="Buscar..."
                                    onChange={(text) => this.filter(text)}
                                    disabled={this.state.disabledbuscar}
                                />
                            </div>

                            <div className="col-12 col-md-6 col-xl-2 d-flex align-items-end">
                                <button
                                    className="btn btn-sm back-istmas w-100"
                                    type="button"
                                    onClick={this.handleChangeListarEstMatCiclo}
                                >
                                    Consultar
                                </button>
                            </div>
                        </div>
                        <br /><h6 className="fw-bold text-center mb-3 text-azul">Estudiantes</h6>
                        <div className="table-responsive mt-4">
                            <table className="table table-hover table-sm-custom">
                                <thead className="table-light">
                                    <tr>
                                        <th className="text-start text-azul">Cédula</th>
                                        <th className="text-start text-azul">Primer Apellido</th>
                                        <th className="text-start text-azul">Segundo Apellido</th>
                                        <th className="text-start text-azul">Primer Nombre</th>
                                        <th className="text-start text-azul">Segundo Nombre</th>
                                        <th className="text-center text-azul">Seleccionar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.currentItems && this.state.currentItems.map((consola) => (
                                        <tr key={consola.id_matricula}>
                                            <td className="oculto">{consola.id_matricula}</td>
                                            <td className="oculto">{consola.ciclo_nivel}</td>
                                            <td className="oculto">{consola.carrera_id}</td>
                                            <td className="oculto">{consola.id_estudiante}</td>
                                            <td className="oculto">{consola.email_estudiante}</td>
                                            <td className="text-start">{consola.numero_identificacion_estudiante}</td>
                                            <td className="text-start">{consola.primer_apellido_estudiante}</td>
                                            <td className="text-start">{consola.segundo_apellido_estudiante}</td>
                                            <td className="text-start">{consola.primer_nombre_estudiante}</td>
                                            <td className="text-start">{consola.segundo_nombre_estudiante}</td>
                                            <td className="text-center">
                                                <input
                                                    type="radio"
                                                    value="1"
                                                    name="afiliado"
                                                    onChange={this.seleccionarEstudianteuno}
                                                    className="afiliado form-check-input"
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="card border-0 mt-4">
                            <h6 className="fw-bold text-center mb-3 text-azul">Datos de Beca del Estudiante</h6>
                            <div className="table-responsive">
                                <table className="table table-hover table-sm-custom">
                                    <thead className="table-light">
                                        <tr>
                                            <th className="text-start text-azul">Monto</th>
                                            <th className="text-start text-azul">% Arancel</th>
                                            <th className="text-start text-azul">% Manutención</th>
                                            <th className="text-start text-azul">Tipo</th>
                                            <th className="text-start text-azul">Financiamiento</th>
                                            <th className="text-start text-azul">Razón 1</th>
                                            <th className="text-start text-azul">Razón 2</th>
                                            <th className="text-start text-azul">Razón 3</th>
                                            <th className="text-start text-azul">Razón 4</th>
                                            <th className="text-start text-azul">Razón 5</th>
                                            <th className="text-start text-azul">Razón 6</th>
                                            <th className="text-start text-azul">Período</th>
                                            <th className="text-center text-azul">Opciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.listabecas.map((consola) => (
                                            <tr key={consola.estudiante_id}>
                                                <td className="text-start">${consola.monto}</td>
                                                <td className="text-start">{consola.porcentaje_arancel}%</td>
                                                <td className="text-start">{consola.porcentaje_manuntencion}%</td>
                                                <td className="text-start">
                                                    {consola.tipo_beca_id === "1" ? "Total" : consola.tipo_beca_id === "2" ? "Parcial" : "NA"}
                                                </td>
                                                <td className="text-start">
                                                    {consola.financiamiento_beca === "1" ? "Fondos Propios" :
                                                        consola.financiamiento_beca === "2" ? "Transferencia del estado" :
                                                            consola.financiamiento_beca === "3" ? "No Donaciones" : "NA"}
                                                </td>
                                                <td className="text-start">{consola.primera_razon_beca === "1" ? "Socioeconómica" : "NA"}</td>
                                                <td className="text-start">{consola.segunda_razon_beca === "1" ? "Excelencia" : "NA"}</td>
                                                <td className="text-start">{consola.tercera_razon_beca === "1" ? "Deportista" : "NA"}</td>
                                                <td className="text-start">{consola.cuarta_razon_beca === "1" ? "Pueblos y Nacionalidades" : "NA"}</td>
                                                <td className="text-start">{consola.quinta_razon_beca === "1" ? "Discapacidad" : "NA"}</td>
                                                <td className="text-start">{consola.sexta_razon_beca === "1" ? "Otra" : "NA"}</td>
                                                <td className="text-start">{consola.descripcion_periodo_academico}</td>
                                                <td className="text-center">
                                                    <button className="btn btn-sm btn-outline-primary me-1" onClick={() => this.mostrarModalModificar(consola)}>
                                                        <i className="fas fa-clipboard-list"></i>
                                                    </button>
                                                    <button className="btn btn-sm btn-outline-danger" onClick={() => this.eliminarBeca(consola)}>
                                                        <i className="fas fa-trash"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="d-flex justify-content-center mt-3">
                                <ReactPaginate
                                    nextLabel=">"
                                    onPageChange={this.handlePageClick}
                                    pageRangeDisplayed={5}
                                    pageCount={this.state.pageCount}
                                    marginPagesDisplayed={2}
                                    previousLabel="<"
                                    pageClassName="page-item"
                                    pageLinkClassName="page-link"
                                    previousClassName="page-item"
                                    previousLinkClassName="page-link"
                                    nextClassName="page-item"
                                    nextLinkClassName="page-link"
                                    breakLabel="..."
                                    breakClassName="page-item"
                                    breakLinkClassName="page-link"
                                    containerClassName="pagination pagination-sm-custom"
                                    activeClassName="active"
                                    renderOnZeroPageCount={null}
                                />
                            </div>
                            <Modal isOpen={this.state.modalReportIngresarBecas}>
                                <ModalHeader className="border-bottom">
                                    <span className="fw-bold small">Registro de Beca</span>
                                </ModalHeader>
                                <ModalBody>
                                    <FormGroup>
                                        <div className="row g-2">
                                            <div className="col-md-4">
                                                <label className="form-label small">Monto:</label>
                                                <input type="text" id="monto" name="monto" onChange={this.handleChange} className="form-control form-control-sm" autoComplete="off" required />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label small">% Arancel:</label>
                                                <input type="text" id="arancel" name="arancel" onChange={this.handleChange} className="form-control form-control-sm" autoComplete="off" required />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label small">% Manutención:</label>
                                                <input type="text" id="manutencion" name="manutencion" onChange={this.handleChange} className="form-control form-control-sm" autoComplete="off" required />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label small">Tipo de Beca:</label>
                                                <select className="form-select form-select-sm" id="tipo_beca_id" name="tipo_beca_id" value={this.state.value} onChange={this.handleChange} required>
                                                    <option value="">Seleccione</option>
                                                    <option value="1">Total</option>
                                                    <option value="2">Parcial</option>
                                                    <option value="3">No aplica</option>
                                                </select>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label small">Financiamiento:</label>
                                                <select className="form-select form-select-sm" id="financiamiento" name="financiamiento" value={this.state.value} onChange={this.handleChange} required>
                                                    <option value="">Seleccione</option>
                                                    <option value="1">Fondos Propios</option>
                                                    <option value="2">Transferencia del estado</option>
                                                    <option value="3">No Donaciones</option>
                                                    <option value="4">No aplica</option>
                                                </select>
                                            </div>
                                            {[1, 2, 3, 4, 5, 6].map((n) => (
                                                <div className="col-md-6" key={n}>
                                                    <label className="form-label small">Razón {n}:</label>
                                                    <select className="form-select form-select-sm" id={`razon${n}`} name={`razon${n}`} value={this.state.value} onChange={this.handleChange} required>
                                                        <option value="">Seleccione</option>
                                                        <option value="1">{["Socioeconómica", "Excelencia Académica", "Deportista", "Pueblos y Nacionalidades", "Discapacidad", "Otra"][n - 1]}</option>
                                                        <option value="2">No aplica</option>
                                                    </select>
                                                </div>
                                            ))}
                                            <div className="col-12">
                                                <label className="form-label small">Periodo Académico:</label>
                                                <select className="form-select form-select-sm" id="periodo" name="periodo" value={this.state.periodo} onChange={this.handleChangePeriodo} required>
                                                    <option value="undefined">Seleccione el periódo</option>
                                                    {this.state.periodos.map(periodo => (
                                                        <option key={periodo.id_periodo_academico} value={periodo.id_periodo_academico}>
                                                            {periodo.descripcion_periodo_academico}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </FormGroup>
                                </ModalBody>
                                <ModalFooter>
                                    <button className="btn btn-outline-success btn-sm" onClick={() => this.registrarBeca()}>
                                        Ingresar
                                    </button>
                                    <button className="btn btn-outline-danger btn-sm" onClick={() => this.ocultarModalIngresar()}>
                                        Cancelar
                                    </button>
                                </ModalFooter>
                            </Modal>

                        </div>
                        <div className="text-center">
                            <button
                                id="agregar"
                                type="button"
                                className="btn btn-sm btn-primary fw-semibold px-3 py-1 shadow-sm"
                                style={{ borderRadius: "8px", fontSize: "0.85rem" }}
                                onClick={() => this.mostrarModalIngresar()}
                            >
                                <i className="fas fa-plus me-1"></i>Registrar Beca
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

